// extracted by mini-css-extract-plugin
export default {"rename":"Rename_rename__tfqXU","input":"Rename_input__u2p8A","icon":"Rename_icon__mH6mq"};